import {Basic} from 'types'
import {areUnitCountersEqual} from 'utils/guestCounterHelpers'
import {StepOrder} from '../../types'

export const setOptionId = (
  userInput: Basic.CartItemInput,
  optionId: string,
  stepOrder: StepOrder
): Basic.CartItemInput => {
  return stepOrder === 'guestsFirst'
    ? {...userInput, optionId, availabilityId: ''}
    : {...userInput, optionId, date: '', availabilityId: ''}
}

export const setDate = (userInput: Basic.CartItemInput, date: string, stepOrder: StepOrder): Basic.CartItemInput => {
  return stepOrder === 'guestsFirst'
    ? {...userInput, date, optionId: '', availabilityId: ''}
    : {...userInput, date, availabilityId: ''}
}

export const setUnitCounters = (
  userInput: Basic.CartItemInput,
  unitCounters: Basic.UnitCounterMap,
  stepOrder: StepOrder
): Basic.CartItemInput => {
  // Only reset date if unit counters have changed
  const hasChanged = !areUnitCountersEqual(userInput.unitCounters, unitCounters)

  if (!hasChanged) {
    return {...userInput, unitCounters}
  }

  return stepOrder === 'guestsFirst'
    ? {...userInput, unitCounters, date: '', availabilityId: '', optionId: ''}
    : {...userInput, unitCounters, date: '', availabilityId: ''}
}

export const setAvailabilityId = (
  userInput: Basic.CartItemInput,
  availabilityId: string,
  stepOrder: StepOrder
): Basic.CartItemInput => {
  return {...userInput, availabilityId}
}
